module.exports = __webpack_public_path__ + "img/coco-club-02.d4f7938d.jpg";